import instance from '@/service/instance';
import { Session } from '@/helpers/types';
import { AxiosPromise } from 'axios';
import moment from 'moment';
import {generateParams} from '@/helpers/functions'

const resource: string = '/session';

export default {
  /**
   * Fetch all sessions from API
   * @param {string} token
   * @param {any[]} [params=[]]
   * @return {Session[]} sessions
   * */
  async list(token: string, params = []): Promise<Session[]> {
    const paramsString = generateParams(params);
    const { data } = await instance.get(`${resource}${paramsString}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return data;
  },
  /**
   * Fetch all sessions from API
   * @param {string} token
   * @return {Session[]} sessions
   * */
  getDaily(token: string): AxiosPromise<Session[]> {
    return instance.get(`${resource}/daily`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  /**
   * Create exercise
   * @param {string} token
   * @param {any} payload
   * */
  /**
   * Fetch all sessions from API
   * @param {string} token
   * @return {Session[]} sessions
   * */
  getWod(token: string): AxiosPromise<Session[]> {
    const date = moment().format('YYYY-MM-DD')
    return instance.get(`${resource}/admin-wod?clientDate=${date}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  /**
   * Create exercise
   * @param {string} token
   * @param {any} payload
   * */
  create(token: string, payload: any): AxiosPromise<Session> {
    return instance.post(`${resource}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  /**
   * Create exercise
   * @param {string} token
   * @param {number} id
   * @param {any} payload
   * */
  update(token: string, id: number, payload: any): AxiosPromise<Session> {
    return instance.patch(`${resource}/${id}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  changeExerciseOrder(token: string, id: number, payload: any): AxiosPromise<Session> {
    return instance.post(`${resource}-exercise/change-order/`, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }
};
